<template>
    <div
        class="game-card"
        style="padding: 0.3rem"
    >
        <div class="game-image position-relative">
            <div @click="$emit('click', game)">
                <!-- :src="game.image_url" -->
                <SkeletonImage
                    :src="imageLinkGenerate(game.gameID.split('_')[1], game.provider)"
                    :alt="game.gameName"
                    class="w-100"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import SkeletonImage from '../SkeletonImage.vue';

export default {
    components: {
        SkeletonImage
    },
    props: {
        game: {
            type: Object,
            required: true
        },
    },
    methods: {
        imageLinkGenerate(gameId, type) {
            if (type === 'PP') {
                return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pp/${gameId}.webp`;
            }
            if (type === "JL") {
                return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/jili/JL_400x540_GameID${gameId}_en-US.webp`;
            }
            if (type === "SPDG") {
                return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/spade/${gameId}.webp`;
            }
            // if (type === "Fastspin") {
            //     return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
            // }
            // if (type === "Playstar") {
            //     return `https://yy24gld.sgp1.cdn.digitaloceanspaces.com/playstar/${gameId}.png`;
            // }
            if (type === "FC") {
                return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/fachai/${gameId}.webp`;
            }
            if (type === "PGS") {
                return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/${gameId}.webp`;
            }
            // if (type === "JOKER" || type === "Joker") {
            //     return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
            // }
            // if (type === "5G") {
            //     return `https://yy24gld.sgp1.cdn.digitaloceanspaces.com/5g/${gameId}.png`;
            // }
            // if (type === "KA") {
            //     return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/ka/${gameId}.webp`;
            // }
            // if (type === "AceWin") {
            //     return `https://yy24gld.sgp1.cdn.digitaloceanspaces.com/acewin/${gameId}.png`;
            // }
            if (type === "JDB") {
                return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/jdb/${gameId}.webp`;
            }

            return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pp/${gameId}.webp`;
        },
    }
};
</script>

<style scoped></style>
